import { lazy, StrictMode, Suspense, type ComponentType } from "react";
import { createRoot } from "react-dom/client";

import { connectedRuntimeRequested } from "./connected/runtimeConfig";
import { firebaseRuntimeRequested } from "./firebase/runtimeConfig";
import { LaunchSplash } from "./components/LaunchSplash";
import { registerProductionServiceWorker } from "./pwaUpdate";
import "./styles.css";

// Start the connected chunk immediately so splash → app does not wait on a
// second waterfall after React mounts.
const connectedAppModule = connectedRuntimeRequested()
  ? import("./ConnectedApp")
  : null;
const firebaseAppModule = firebaseRuntimeRequested()
  ? import("./FirebaseConnectedApp")
  : null;

const RootApp = firebaseRuntimeRequested()
  ? lazy(() => firebaseAppModule!.then((module) => ({ default: module.FirebaseConnectedApp as ComponentType })))
  : connectedRuntimeRequested()
    ? lazy(() => connectedAppModule!.then((module) => ({ default: module.ConnectedApp as ComponentType })))
    : lazy(() => import("./App").then((module) => ({ default: module.App as ComponentType })));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Suspense fallback={<LaunchSplash />}>
      <RootApp />
    </Suspense>
  </StrictMode>
);

registerProductionServiceWorker();
